<template>
  <!-- Establece la altura al 100% de la ventana -->
  <div style="height: 50vh">
    <LineChartGenerator
      v-if="chartData?.datasets?.length > 0"
      :chart-options="computed_chart_options"
      style="height: 100%"
      :chart-data="chartData"
    />
  </div>
</template>

<script>
import { Line as LineChartGenerator } from "vue-chartjs";
import zoomPlugin from "chartjs-plugin-zoom";
import annotationPlugin from "chartjs-plugin-annotation";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale,
  Legend,
} from "chart.js";

ChartJS.register(
  Legend,
  Title,
  Tooltip,
  LineElement,
  LinearScale,
  PointElement,
  zoomPlugin,
  annotationPlugin,
  CategoryScale
);

export default {
  name: "LineChart",

  components: {
    LineChartGenerator,
  },

  props: {
    chartData: Object,
  },

  data() {
    return {
      chartOptions: {
        responsive: true,
        animation: false, // Desactivar animación
        maintainAspectRatio: false,

        legend: {
          display: false,
          position: "bottom", // Posición de la leyenda (top, bottom, left, right)
          labels: {
            fontColor: "black", // Color del texto de la leyenda
          },
        },

        tooltips: {
          callbacks: {
            label: function (tooltipItem) {
              let label = this.chartData?.datasets[tooltipItem.datasetIndex]?.label || "";
              if (label) {
                label += ":ssss";
              }
              label += tooltipItem.yLabel;
              return "label";
            },
          },
        },

        scales: {
          y: {
            suggestedMin: 0,
            suggestedMax: 0,
          },
        },

        interaction: {
          mode: "index",
          intersect: false,
        },

        onHover: function (event, chartElement) {
          if (chartElement.length > 0) {
            const retrievedCanvas = event.chart.$context.chart.canvas;
            const retrievedElement = chartElement[0];
            const mouseX = retrievedElement.element.x;
            const ctx = retrievedCanvas.getContext("2d");

            ctx.beginPath();
            ctx.moveTo(mouseX, 0);
            ctx.strokeStyle = "#000";
            ctx.lineWidth = 1;
            ctx.lineTo(mouseX, retrievedCanvas.height);
            ctx.stroke();
          }
        },
      },
    };
  },

  computed: {
    computed_chart_options() {
      const options = { ...this.chartOptions };
      options.scales.y.suggestedMax = Math.ceil((this.chartData?.max_value || 0) * 1.1);
      return options;
    },

    datasets() {
      return this.chartData?.datasets;
    },
  },

  watch: {
    datasets(newVal) {
      if (newVal?.every((v) => v?.data?.length > 0)) {
        this.$emit("render-complete");
      }
    },
  },
};
</script>
